import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/admin/api";

const Ctx = createContext(null);

export function AdminAuthProvider({ children }) {
    const [admin, setAdmin] = useState(null); // null=unknown, false=guest, obj=logged-in
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const t = localStorage.getItem(TOKEN_KEY);
        if (!t) {
            setAdmin(false);
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setAdmin(r.data))
            .catch(() => {
                localStorage.removeItem(TOKEN_KEY);
                setAdmin(false);
            })
            .finally(() => setLoading(false));
    }, []);

    async function login(email, password) {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem(TOKEN_KEY, data.token);
        setAdmin(data.admin);
        return data.admin;
    }

    async function logout() {
        try {
            await api.post("/auth/logout");
        } catch (_e) {
            /* ignore */
        }
        localStorage.removeItem(TOKEN_KEY);
        setAdmin(false);
    }

    return (
        <Ctx.Provider value={{ admin, loading, login, logout }}>
            {children}
        </Ctx.Provider>
    );
}

export function useAdminAuth() {
    const v = useContext(Ctx);
    if (!v) throw new Error("useAdminAuth must be used within AdminAuthProvider");
    return v;
}
